import { Paper, Box, } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import 'react-markdown-editor-lite/lib/index.css';


const UserMessage = ({ dataItem }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start', // Align items to the bottom
                // padding: 1,
                justifyContent: 'flex-start', // Align the message to the right
                position: 'relative',
                // border: "2px solid",
            }}
        >

            <Box
                // elevation={1}
                sx={{
                    // padding: 1,
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: "8px 8px 0px 0px",
                    flexGrow: 1,
                    // backgroundColor: 'primary.light',
                    // color: 'primary.contrastText',
                    width: '100%',
                    wordWrap: 'break-word',
                    position: 'relative',
                    display: "flex",
                    // alignItems: 'flex-start',
                    // backgroundColor: "text.disabled",
                }}
            >
                <Box
                    sx={{
                        wordWrap: 'break-word',
                        overflow: "hidden",
                        flexGrow: 1,
                        backgroundColor: "primary.dark",
                        color: "primary.contrastText",
                        borderRadius: "8px 8px 0px 0px",
                        paddingX: 2,
                        // marginLeft: 1,
                    }}
                >
                    <ReactMarkdown
                        components={{
                            p: ({ node, ...props }) => <p style={{ fontWeight: 'bold' }} {...props} />,
                        }}
                    >
                        {dataItem.request_data}
                    </ReactMarkdown>
                </Box>
            </Box>
        </Box>
    );
};


export default UserMessage;